import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Col,
  Form,
  Image,
  ListGroup,
  Nav,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import IMAGES from "constants/images";
import {
  getFollowersList,
  getFollowingList,
  removeFollowOrUnfollow,
} from "api/ActivityService";
import debounce from "lodash.debounce";
import { Modal } from "react-bootstrap";
import { Sentry } from "react-activity";
import { getMyProfileDetails } from "api/authService";
import { useAuth } from "context/UserContext";
import { useFetchProfile } from "hooks/useFetchProfile";
import Loader from "components/Loader";
import { Icon } from "@iconify/react";

const FollowFollowing = ({ followTab,setShowFollowers }) => {
  const [activeTab, setActiveTab] = useState(followTab ||"Followers");
  const { refetchProfile } = useAuth();
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedFollowId, setSelectedFollowId] = useState(null);
  const [removeLoader, setRemoveLoader] = useState(false);
  console.log('activeTab,followTab', activeTab)
  const fetchData = async (tab, page, search) => {
    setLoading(true);
    try {
      const apiFn = tab === "Followers" ? getFollowersList : getFollowingList;
      const res = await apiFn(page, 10, search);
      if (res.success) {
        const data = res.body.data.map((item) => {
          const user = tab === "Followers" ? item.senderId : item.receiverId;
          return {
            id: user._id,
            name:
              // user.role === "vendor"
              //   ? user.companyName
              //   : 
                `${user.firstName} ${user.lastName}`,
            email: user.email,
            image: user.profileUrl || IMAGES.User2_Img,
            followers: `${user.followersCount || 0}`,
            followid: item._id,
          };
        });

        if (page === 1) {
          tab === "Followers" ? setFollowers(data) : setFollowing(data);
        } else {
          tab === "Followers"
            ? setFollowers((prev) => [...prev, ...data])
            : setFollowing((prev) => [...prev, ...data]);
        }

        setTotalPages(res.body.total_pages);
      }
    } catch (err) {
      console.error("Fetch followers/following failed", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab, 1, searchTerm);
    setPage(1);
  }, [activeTab, searchTerm]);

  const handleSearch = debounce((e) => {
    setSearchTerm(e.target.value);
  }, 500);

  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchData(activeTab, nextPage, searchTerm);
  };

  const handleRemove = async (targetUserId) => {
    try {
      setRemoveLoader(true);
      const res = await removeFollowOrUnfollow(targetUserId);
      if (res.success) {
        refetchProfile();

        // Refetch current tab data after removal
        fetchData(activeTab, 1, searchTerm);
        setPage(1);
      }
      setRemoveLoader(false);
      setShowConfirmModal(false);
    } catch (err) {
      console.error("Error while removing/unfollowing:", err);
    }
  };

  return (
    <div className="tab_1_style">
      {/* Search */}
     
     
     <div className="searchMentions d-flex align-items-center gap-4 w-100  ">
      <div className="d-flex align-items-center  justify-content-center header_profile2" style={{width: "48px",height: "48px",borderRadius: "50%",border: "1px solid #6E6E73"}}>
        <Icon icon="mdi:arrow-left" style={{fontSize: "24px",height: "48px",width: "48px",padding: "10px"}} onClick={() => {setShowFollowers(false)}}/>
      </div>
        <div className="searchInput " style={{marginBottom: "0px" ,width: "100%" ,maxWidth: "290px"}}>
          <Image src={IMAGES.Search_Normal} alt="search" />
          <Form.Control placeholder="Search user..." onChange={handleSearch} />
        </div>
     </div>


      {/* Tabs */}
      <div className="nav_Flex mt-3 mb-4 header_profile3">
        <Nav variant="tabs" activeKey={activeTab}>
          {["Followers", "Following"].map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                eventKey={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  backgroundColor:
                    activeTab === tab ? "#E91515" : "transparent",
                  color: activeTab === tab ? "white" : "black",
                }}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>
      <div className="nav_Flex mt-3 mb-4 header_profile2 w-100">
        <Nav variant="tabs" activeKey={activeTab}>
          {["Followers", "Following"].map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                eventKey={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  width: "100%",
                  backgroundColor:
                    activeTab === tab ? "#E91515" : "transparent",
                  color: activeTab === tab ? "white" : "black",
                }}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>

      {/* List */}
      <div className="followers_style">
        <ListGroup className="follower-list">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center py-4" style={{height: '40vh'}}>
              <Sentry color="#e91515" size={40} speed={1} animating={true} />
              {/* <Loader  style={{width: 100, height: 100}} /> */}
            </div>
          ) : (
            (activeTab === "Followers" ? followers : following).map((user) => (
              <ListGroup.Item
                key={user.id}
                className="d-flex align-items-center justify-content-between"
              >
                <div
                  onClick={() => {
                    navigate(`/public-profile/${user.id}`);
                  }}
                  className="d-flex align-items-center cursor-pointer"
                >
                  <Image
                    src={user.image}
                    roundedCircle
                    width={50}
                    height={50}
                    className="me-3"
                  />
                  <div>
                    <strong>{user.name}</strong>
                    <p className="text-muted mb-0">
                      {user.followers} Followers
                    </p>
                  </div>
                </div>
                <Button
                  variant="info"
                  onClick={() => {
                    setSelectedFollowId(user.followid);
                    setShowConfirmModal(true);
                  }}
                  className="border-radius-100"
                >
                  {removeLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : activeTab === "Followers" ? (
                    "Remove"
                  ) : (
                    "Unfollow"
                  )}
                </Button>
              </ListGroup.Item>
            ))
          )}
        </ListGroup>

        <Modal
          show={showConfirmModal}
          onHide={() => setShowConfirmModal(false)}
          centered
          className="confirmation-modal"
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title className="text-center w-100 fw-bold">
              {activeTab === "Followers" ? "Remove Follower" : "Unfollow User"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center py-4">
            {/* <div className="mb-4">
              <i className="fas fa-exclamation-circle text-warning fa-3x"></i>
            </div> */}
            <p className="mb-0">
              Are you sure you want to{" "}
              {activeTab === "Followers"
                ? "remove this follower"
                : "unfollow this user"}
              ?
              <br />
              <span className="text-muted small">
                This action cannot be undone.
              </span>
            </p>
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center gap-2">
            <Button
              variant="outline-secondary"
              onClick={() => setShowConfirmModal(false)}
              className="px-4"
            >
              Cancel
            </Button>
            <Button
              disabled={removeLoader}
              variant="danger"
              onClick={() => {
                handleRemove(selectedFollowId);
                setShowConfirmModal(false);
              }}
              className="px-4"
            >
              {activeTab === "Followers" ? "Remove" : "Unfollow"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Load More */}
        {page < totalPages && (
          <div className="text-center mt-3">
            <Button
              onClick={loadMore}
              disabled={loading}
              variant="outline-primary"
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Load More"}
            </Button>
          </div>
        )}

        {/* No Data */}
        {!(activeTab === "Followers" ? followers.length : following.length) &&
          !loading && (
            <Col xs={12}>
              <div className="text-center py-5">
                <Image
                  src={IMAGES.emptyState}
                  alt=""
                  height="200px"
                  width="200px"
                  // className="mb-4"
                  // className="imgUser"
                />
                <p className="text-center text-muted mt-4">
                  No {activeTab} found.
                </p>
              </div>
            </Col>
          )}
      </div>
    </div>
  );
};

export default FollowFollowing;
